import { c } from 'ttag';

import { refusalCode } from '../../graphql/refusalCode';
import { Refusal } from '../accounts/portalAccess';

export const journalRefusalOf = (error: unknown): Refusal => {
    switch (refusalCode(error)) {
        case 'MISSING_PERMISSION':
            return {
                title: c('Activity log refusal').t`Your role does not let you read the activity log.`,
                guidance: c('Activity log refusal')
                    .t`The audit log is gated by the same permission as the accounts list, so that nobody lands on a screen where everything refuses. The log was refused, not answered: this is not an empty history. Ask an administrator for that permission.`,
            };
        case 'INTERNAL_STAFF_ONLY':
            return {
                title: c('Activity log refusal').t`This screen belongs to the back-office.`,
                guidance: c('Activity log refusal')
                    .t`Reading the trace of administration gestures is a Freelance.com matter, so a client-side role cannot carry it whatever its permissions. The scope of the role is checked before the permission, which is why a custom role holding the right is refused too.`,
            };
        case 'NO_ACTIVE_MEMBERSHIP':
            return {
                title: c('Activity log refusal').t`Your session carries no active membership.`,
                guidance: c('Activity log refusal')
                    .t`Your identity is recognised but it is attached to nothing right now, so there is no perimeter to read the log through. Sign in again; if it happens once more, your own access has to be reopened.`,
            };
        case 'NOT_AUTHENTICATED':
            return {
                title: c('Activity log refusal').t`Your session is no longer valid.`,
                guidance: c('Activity log refusal').t`Sign in again, then open this log back.`,
            };
        default:
            return {
                title: c('Activity log refusal').t`The activity log could not be read.`,
                guidance: c('Activity log refusal')
                    .t`This refusal is not one the screen knows how to read, so nothing here says what to do about it. Above all it does not say the history is empty: nothing was read. The server's answer is below; it is what the support desk needs.`,
                detail: error instanceof Error ? error.message : String(error),
            };
    }
};
